import React from "react";
import { Input } from "reactstrap";
import { renderText } from "../../../../components/EventLabel2/EventLabel2";
import { eventLabelGroupsConstants } from "../../../constants/eventLabelGroups.contansts";
import { ChatEmojiPicker } from "./ChatEmojiPicker";

export function MessageInput(props) {

  const {onTyping, fontFamily, color, inputColor, inputBackground, background, text, preview } = props;

  return (
    <div className="text-bar__field">
      <Input
        className={"chat-input" /*  + (text.length > 100 ? ' smooth-shadow floating-input' : '') */}
        placeholder={renderText("TypeSomething", eventLabelGroupsConstants.CHAT_LABEL_GROUP)}
        autoFocus={true}
        disabled={preview}
        maxLength={500}
        type={/* text.length > 100 ? "textarea" :  */ "text"}
        style={{
          background,
          width: "85%",
          margin: "unset",
          backgroundColor: inputBackground,
          color: inputColor,
          fontFamily,
          padding: "0px 5px 0px 10px",
        }}
        value={text}
        onChange={(e) => onTyping(e.target.value)}
      />
    {/*   <ChatEmojiPicker {...props} /> */}
    </div>
  );
}
